// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VWt1BfAlIrWowOIxPVM0{flex-direction:column;gap:20px;display:flex}.IqYjz24dnDQSaFd9wOym{align-items:center;gap:8px;display:flex}.XpyQuacIB48k_HPzd6RH{border-radius:4px;width:12px;height:12px}.IVCOrUyeCMsUfk5Yyh0q{background:var(--green-60)}.h0IJahUCoN45LLKz15qW{background:var(--yellow-70)}.oKSDVT7PA_gj3j8r5VBn{background:var(--red-80)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"category": `VWt1BfAlIrWowOIxPVM0`,
	"categoryLabel": `IqYjz24dnDQSaFd9wOym`,
	"dot": `XpyQuacIB48k_HPzd6RH`,
	"dot_green": `IVCOrUyeCMsUfk5Yyh0q`,
	"dotGreen": `IVCOrUyeCMsUfk5Yyh0q`,
	"dot_orange": `h0IJahUCoN45LLKz15qW`,
	"dotOrange": `h0IJahUCoN45LLKz15qW`,
	"dot_red": `oKSDVT7PA_gj3j8r5VBn`,
	"dotRed": `oKSDVT7PA_gj3j8r5VBn`
};
export default ___CSS_LOADER_EXPORT___;
